export default __webpack_public_path__ + "static/media/hide-highlight.683a4902.svg";